import { Tab, Tabs, tokens } from '@cast/design-system';

export type NotificationsTab = 'active' | 'catalogue';

type Props = {
  activeTab: NotificationsTab;
  onChange: (tab: NotificationsTab) => void;
};

export const NotificationsTabs = ({ activeTab, onChange }: Props) => {
  const handleChange = (_: React.SyntheticEvent, value: NotificationsTab) => {
    onChange(value);
  };

  return (
    <Tabs
      value={activeTab}
      onChange={handleChange}
      size="medium"
      testId="notifications-tabs"
      sx={{
        borderBottom: `1px solid ${tokens.theme.border.structural.neutralSubtle}`,
        minHeight: 40,
        '& .MuiTabs-flexContainer': {
          gap: 24,
        },
      }}
    >
      <Tab
        value="active"
        label="Your notifications"
        testId="notifications-tab-active"
      />
      <Tab
        value="catalogue"
        label="Catalogue"
        testId="notifications-tab-catalogue"
      />
    </Tabs>
  );
};
